import { SousDispositif as SousDispositifAF, SousDispositifLibelle as SousDispositifLibelleAF } from '@/features/domaine/types/opco/Demande/AF'
import { SousDispositif as SousDispositifCPRO, SousDispositifLibelle as SousDispositifLibelleCPRO } from '@/features/domaine/types/opco/Demande/CPRO'
import { SousDispositif as SousDispositifCXPI, SousDispositifLibelle as SousDispositifLibelleCXPI } from '@/features/domaine/types/opco/Demande/CXPI'
import { SousDispositif as SousDispositifOutilFPE, SousDispositifLibelle as SousDispositifLibelleOutilFPE } from '@/features/domaine/types/opco/Demande/OUTILFPE'
import { SousDispositif as SousDispositifPROA, SousDispositifLibelle as SousDispositifLibellePROA } from '@/features/domaine/types/opco/Demande/PROA'

export const SousDispositif = [
  ...SousDispositifAF,
  ...SousDispositifCPRO,
  ...SousDispositifCXPI,
  ...SousDispositifPROA,
  ...SousDispositifOutilFPE
] as const
export type SousDispositif = (typeof SousDispositif)[number]

export const SousDispositifLibelle : Record<SousDispositif, string> = {
  ...SousDispositifLibelleCPRO,
  ...SousDispositifLibelleAF,
  ...SousDispositifLibelleCXPI,
  ...SousDispositifLibelleOutilFPE,
  ...SousDispositifLibellePROA
}
